<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>提现计划</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-input v-model="query.name" placeholder="请输入计划名称" class="handle-input mr10"></el-input>
                <el-select v-model="query.planTypeId" placeholder="请选择提醒类型">
					<el-option key="" label="请选择" value=""></el-option>
					<el-option v-for="item in notifyPlanTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				</el-select>&nbsp;&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="启动" value="0"></el-option>
					<el-option key="1" label="禁用" value="1"></el-option>
				</el-select>&nbsp;&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="table"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="planTypeId" label="提醒类型" :formatter="planTypeFormattor"></el-table-column>
				<el-table-column prop="name" label="计划名称"></el-table-column>
                <el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						{{scope.row.status==0?"启用":"禁用"}}
					</template>
				</el-table-column>
				<el-table-column prop="execTime" label="最新执行时间"></el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-form-item label="提醒类型" prop="planTypeId">
							<el-select v-model="form.planTypeId" placeholder="提醒类型">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option v-for="item in notifyPlanTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="提醒内容" prop="content">
							<el-input type=textarea :rows=5 v-model="form.content"> </el-input>
						</el-form-item>
						<el-form-item label="说明" prop="remark">
							<el-input type=textarea :rows=3 v-model="form.remark"> </el-input>
						</el-form-item>
						<el-form-item label="是否启用" prop="start">
							<el-switch v-model="form.start"></el-switch>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="提醒计划" name="planTab">
						<el-form-item label="提醒方式" prop="plan.frequency">
							<el-select v-model="plan.frequency" placeholder="请选择提醒方式" @change="frequencyChange">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option key=0 label="每天提醒" value =0></el-option>
								<el-option key=1 label="每周提醒" value =1></el-option>
								<el-option key=2 label="每月提醒" value =2></el-option>
								<el-option key=3 label="每年提醒" value =3></el-option>
								<el-option key=4 label="到期前后提醒" value =4></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="提醒月份" v-if="plan.frequency==3">
							<el-checkbox-group 
								v-model="plan.month">
								<el-checkbox style = "width:80px;" v-for="month in monthKV" :label="month.key" :key="month.key">{{month.value}}</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="提醒星期" v-if="plan.frequency==1">
							<el-checkbox-group 
								v-model="plan.weekDay">
								<el-checkbox style = "width:80px;" v-for="week in weekDayKV" :label="week.key" :key="week.key">{{week.value}}</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="提醒日期" v-if="plan.frequency==2||plan.frequency==3">
							<el-checkbox-group 
								v-model="plan.date">
								<el-checkbox style = "width:80px;" v-for="date in dateKV" :label="date.key" :key="date.key">{{date.value}}</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="提醒时间" v-if="plan.frequency&&plan.frequency!=''">
							<el-checkbox-group 
								v-model="plan.time">
								<el-checkbox style = "width:80px;" v-for="hour in hoursKV" :label="hour.key" :key="hour.key">{{hour.value}}</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="自定义配置" name="configTab">
						<el-form-item label="配置内容" prop="config">
							<el-input type=textarea :rows=10 v-model="form.config"> </el-input>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchNotifyPlanData, saveNotifyPlan, deleteNotifyPlan, getNotifyPlan, getNotifyPlanTypeKv} from '../../../api/index';
export default {
    name: 'notify-plan',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			plan:{},
			rules: {
                planTypeId: [{ required: true, message:'请选择提醒类型', trigger: 'blur' }],
				content: [{ required: true, message: '请输入提醒内容', trigger: 'blur' }],
				start: [{ required: true, message: '请选择状态', trigger: 'blur' }]
            },
			notifyPlanTypeKV : [],
			activeName:"baseTab",
			hoursKV:[{"key":8,"value":"8:00"},{"key":9,"value":"9:00"},{"key":10,"value":"10:00"},{"key":11,"value":"11:00"},{"key":12,"value":"12:00"},{"key":13,"value":"13:00"},
			{"key":14,"value":"14:00"},{"key":15,"value":"15:00"},{"key":16,"value":"16:00"},{"key":17,"value":"17:00"},{"key":18,"value":"18:00"},{"key":19,"value":"19:00"},{"key":20,"value":"20:00"}],
			weekDayKV:[{"key":2, "value":"星期一"},{"key":3, "value":"星期二"},{"key":4, "value":"星期三"},{"key":5, "value":"星期四"},{"key":6, "value":"星期五"},{"key":7, "value":"星期六"},{"key":1, "value":"星期天"}],
			monthKV:[{"key":0, "value":"一月"},{"key":1, "value":"二月"},{"key":2, "value":"三月"},{"key":3, "value":"四月"},{"key":4, "value":"五月"},{"key":5, "value":"六月"},{"key":6, "value":"七月"},
			{"key":7, "value":"八月"},{"key":8, "value":"九月"},{"key":9, "value":"十月"},{"key":10, "value":"十一月"},{"key":11, "value":"十二月"}],
			dateKV:[]
        };
    },
    created() {
		this.getNotifyPlanType();
        this.getData();
    },
    methods: {
		initPlan() {
			this.$set(this.plan, "time", []);
			this.$set(this.plan, "date", []);
			this.$set(this.plan, "weekDay", []);
			this.$set(this.plan, "month", []);
		},
		planTypeFormattor(row, column, cellValue) {
			let index = this.notifyPlanTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.notifyPlanTypeKV[index].value;
		},		
		//模式变更
		frequencyChange(val) {
			this.initPlan();
			if (val == "") {
				return;
			}
			this.dateKV = [];
			if (val == 2 || val == 3) {
				let item = {};
				this.buildDate(31);
			}
		},
		//发送月份变更
		monthChange(val) {
			this.$set(this.plan, "date", "");
			if (val == "") {
				this.dateKV = [];
				return;
			}
			if (val == 1) {
				this.buildDate(28);
			} else if (val == 0 || val == 2 || val == 4 || val == 6 || val == 7 || val == 9 || val == 11) {
				this.buildDate(31);
			} else {
				this.buildDate(30);
			}
		},
		//构建发送日期
		buildDate(size) {
			for (var i = 1; i <= size; i++) {
				let item = {};
				item["key"] = i;
				item["value"] = i + "日";
				this.dateKV.push(item);
			}
		},
		getNotifyPlanType(){
			getNotifyPlanTypeKv().then(res => {
				if (res.code == 0 ) {
					this.notifyPlanTypeKV = res.data;
				} else {
					this.$message.error("获取提醒类型失败！" + res.message);
				}
			});
		},
        // 获取数据
        getData() {
            fetchNotifyPlanData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteNotifyPlan([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, "start", true);
			this.$set(this.plan, "frequency", "");
			this.title = "添加新纪录";
			this.initPlan();
			this.activeName = "baseTab";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.activeName = "baseTab";
			getNotifyPlan(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.plan = JSON.parse(res.data.sendPlan);
					this.$set(this.form, 'start', res.data.status==0);
					this.dateKV = [];
					this.validDateKV = [];
					if (this.plan.frequency == 2 || this.plan.frequency == 3) {
						this.buildDate(31);
					}
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.plan.frequency == undefined || this.plan.frequency == "") {
						this.$message.error(`请选择提醒方式！`);
						return;
					}
					
					if (this.plan.frequency == "1") {
						if (this.plan.weekDay.length == 0) {
							this.$message.error(`请选择提醒星期！`);
							return;
						}
					}
					if (this.plan.frequency == "2") {
						if (this.plan.date.length == 0) {
							this.$message.error(`请选择提醒日期！`);
							return;
						}
					}
					if (this.plan.frequency == "3") {
						if (this.plan.month.length == 0) {
							this.$message.error(`请选择提醒月份！`);
							return;
						}
						if (this.plan.date.length == 0) {
							this.$message.error(`请选择提醒日期！`);
							return;
						}
					}
					if (this.plan.time.length == 0) {
						this.$message.error(`请选择提醒时间！`);
						return;
					}
					this.$set(this.form, "sendPlan", JSON.stringify(this.plan));
					this.$set(this.form, "status", this.form.start?0:1);
					this.savePlan(this.form);
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }, 
		savePlan(data) {
			saveNotifyPlan(data).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.editVisible = false;
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
